const catalogue4 = (data) => {
  const node = data.node;
  const catalogueList = node.list;
  const color = data.color;
  let htmlText = "<ul>";
  for (let i = 0; i < catalogueList.length; i++) {
    const item = catalogueList[i];
    htmlText += `<li style="text-align: left;"><span style="font-size: 25px;font-family: Microsoft Yahei;">${item}</span></li>`;
  }
  htmlText += "</ul>";
  const id = Math.random().toString(36).slice(-8);
  return {
    id: id,
    elements: [
      {
        type: "shape",
        id: "90KM58c2wC",
        width: 58.69996719160105,
        height: 58.69996719160105,
        left: 48.64000984251968,
        top: 40.60999015748031,
        viewBox: [58.69996719160105, 58.69996719160105],
        path: "M 12.694092164637308 0 L 46.005875026963736 0 Q 58.69996719160105 0 58.69996719160105 12.694092164637308 L 58.69996719160105 46.005875026963736 Q 58.69996719160105 58.69996719160105 46.005875026963736 58.69996719160105 L 12.694092164637308 58.69996719160105 Q 0 58.69996719160105 0 46.005875026963736 L 0 12.694092164637308 Q 0 0 12.694092164637308 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
        pathFormula: "roundRect",
        keypoint: 0.2162538204357568,
        shadow: { h: 1, v: 1, blur: 2, color: "#000" },
      },
      {
        type: "text",
        id: "r16O4vruX7",
        width: 137.91879921259843,
        height: 62.89009186351706,
        left: 122.25787401574803,
        top: 102.32808398950131,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content:
          '<p style="text-align: center;"><strong><span style="font-size: 46.09375px;"><span style="font-family: 黑体;">目录</span></span></strong></p>',
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
      {
        type: "text",
        id: "pQhiYKPljy",
        width: 538.28125,
        height: 254.6875,
        left: 377.00787401574803,
        top: 146.77312992125985,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        rotate: 0,
        content: htmlText,
        defaultColor: "#333",
      },
      {
        type: "line",
        id: "VZaP2nQgiu",
        width: 2,
        left: 375.1291010498688,
        top: 132.39583333333334,
        start: [0, 0],
        end: [429.5759514435695, 0],
        style: "solid",
        color: `${color}`,
        points: ["", ""],
      },
    ],
    background: { type: "solid", color: "#ffffff" },
  };
};
export default catalogue4;
